module.exports = __webpack_public_path__ + "static/img/c-mic.3ca9635.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c-mic.png
// module id = aWA8
// module chunks = 1